import { APP_VERSION } from "./appVersion";

export async function checkVersionAndReload() {
  try {
    // Safe PUBLIC_URL fallback
    const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    const url = `${publicUrl}/version.json`;

    const response = await fetch(url, { cache: "no-store" });

    if (!response.ok) {
      // If the version.json is missing (404) it's a strong signal the server
      // has been updated and the old client may be stale. In that case reload
      // so the browser requests the latest HTML/assets. For other non-OK
      // statuses (500, etc.) don't force a reload because that may be a
      // transient server error.
      if (response.status === 404) {
        console.warn("version.json not found (404). Assuming a version mismatch — reloading to fetch latest assets.", "url:", url);
        const sep = window.location.search ? '&' : '?';
        window.location.replace(window.location.pathname + window.location.search + sep + '_reload=' + Date.now());
        return true;
      }

      console.warn("Version check failed with status:", response.status, "url:", url);
      return false;
    }

    // Verify that the version file contains valid json.
    // Some servers/CDNs may omit or use different content-type values
    // (e.g. "application/json; charset=utf-8" or "application/ld+json").
    // We'll log if the content-type doesn't look like JSON, but still
    // attempt to parse the body so we don't fail unnecessarily.
    const contentType = (response.headers.get("content-type") || "").toLowerCase();

    if (!contentType.includes("json")) {
      console.warn(
        "version.json did not advertise JSON in Content-Type. Attempting to parse anyway.",
        {
          url,
          contentType: contentType || "<missing>"
        }
      );
    }

    let serverVersion;
    try {
      serverVersion = await response.json();
    } catch (err) {
      console.warn("version.json response body is not valid JSON:",
        {
          url,
          error: err
        });
      return false;
    }


    if (!serverVersion.version || !APP_VERSION.version) {
      console.warn("Version check skipped because version is missing.", {
        serverVersion,
        APP_VERSION
      });
      return false;
    }

    if (serverVersion.version !== APP_VERSION.version) {
      console.warn("New frontend version detected. Reloading page.", {
        runningVersion: APP_VERSION,
        serverVersion: serverVersion
      });

      // Reload to get the latest version
      window.location.reload();

      return true;
    }

    return false;
  } catch (error) {
    console.warn("Unable to check frontend version.", error);
    return false;
  }
}